/**
* 介绍流程
*/
<template>
	<div class="min-h-screen bg-gray-50">

		<div style="display: flex;">
			<div style="flex: 1;">
				<nav class="bg-white shadow-sm h-16 flex items-center px-8">
					<h1 class="text-2xl font-semibold text-gray-800">
						<!-- 流程示意图 -->
						{{ $t('language000307')}}
					</h1>
				</nav>

				<div class="max-w-4xl mx-auto py-12 px-4">
					<div class="space-y-8">
						<div v-for="(step, index) in certificationSteps" :key="index"
							class="relative flex items-start gap-8 group">
							<!-- 时间线 -->
							<div class="flex flex-col items-center">
								<div :class="{
				      'w-12 h-12 rounded-full flex items-center justify-center border-2': true,
				      'bg-blue-50 border-blue-500 text-blue-500': step.active,
				      'bg-green-50 border-green-500 text-green-500': step.completed,
				      'bg-gray-100 border-gray-300 text-gray-400': !step.active && !step.completed
				    }">
									<i v-if="step.completed" class="fas fa-check text-lg"></i>
									<span v-else class="font-medium">{{ index + 1 }}</span>
								</div>
								<div v-if="index !== certificationSteps.length - 1" class="w-0.5 h-24 bg-gray-200">
								</div>
							</div>

							<!-- 内容区域 -->
							<div class="flex-1 pt-1">
								<div :class="{
				      'bg-white rounded-lg shadow-sm p-6 border transition-all duration-200': true,
				      'border-blue-200 shadow-blue-100': step.active,
				      'border-gray-100': !step.active
				    }">
									<h3 :class="{
				        'text-xl font-medium mb-3': true,
				        'text-blue-600': step.active,
				        'text-gray-800': !step.active
				      }">{{ step.title }}</h3>
									<p class="text-gray-600 mb-4 leading-relaxed">{{ step.description }}</p>

									<!-- 注意事项 -->
									<div v-if="step.notes"
										class="bg-amber-50 border border-amber-100 rounded-lg p-4 mb-4">
										<div class="flex items-start gap-3">
											<i class="fas fa-exclamation-circle text-amber-500 mt-1"></i>
											<p class="text-amber-700 text-sm">{{ step.notes }}</p>
										</div>
									</div>

									<!-- 操作按钮 -->
									<div class="flex items-center gap-4" v-if="step.active">
										<button
											class="!rounded-button bg-blue-600 text-white px-6 py-2 hover:bg-blue-700 transition-colors whitespace-nowrap">
											确认完成
										</button>
										<button
											class="!rounded-button border border-gray-300 px-6 py-2 text-gray-600 hover:bg-gray-50 transition-colors whitespace-nowrap">
											查看详情
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>


					<!-- 提示信息 -->
					<div class="mt-3 flex items-start gap-2 mt-10">
						<i class="fas fa-info-circle text-blue-500 mt-0.5 "></i>
						<p class="text-sm text-gray-500">
							<!-- 重复最后两个步骤实现不同的功能 -->
							{{ $t('language000343') }}
						</p>
					</div>


				</div>
			</div>

			<div style="width: 60px; display: flex; justify-content: center; align-items: center;">
				<div style="width: 1px; height: 100%; background-color: #ddd;"></div>
			</div>


			<div style="flex: 1;">
				<nav class="bg-white shadow-sm h-16 flex items-center px-8">
					<h1 class="text-2xl font-semibold text-gray-800">
						<!-- 流程示意图 -->
						{{ $t('language000307')}}(4G)
					</h1>
				</nav>

				<div class="max-w-4xl mx-auto py-12 px-4">
					<div class="space-y-8">
						<div v-for="(step, index) in certificationSteps4G" :key="index"
							class="relative flex items-start gap-8 group">
							<!-- 时间线 -->
							<div class="flex flex-col items-center">
								<div
									:class="{'w-12 h-12 rounded-full flex items-center justify-center border-2': true,'bg-blue-50 border-blue-500 text-blue-500': step.active,  'bg-green-50 border-green-500 text-green-500': step.completed,'bg-gray-100 border-gray-300 text-gray-400': !step.active && !step.completed }">
									<i v-if="step.completed" class="fas fa-check text-lg"></i>
									<span v-else class="font-medium">{{ index + 1 }}</span>
								</div>
								<div v-if="index !== certificationSteps4G.length - 1" class="w-0.5 h-24 bg-gray-200">
								</div>
							</div>

							<!-- 内容区域 -->
							<div class="flex-1 pt-1">
								<div
									:class="{ 'bg-white rounded-lg shadow-sm p-6 border transition-all duration-200': true, 'border-blue-200 shadow-blue-100': step.active,  'border-gray-100': !step.active }">
									<h3
										:class="{ 'text-xl font-medium mb-3': true, 'text-blue-600': step.active,  'text-gray-800': !step.active }">
										{{ step.title }}
									</h3>
									<p class="text-gray-600 mb-4 leading-relaxed">{{ step.description }}</p>
									<!-- 注意事项 -->
									<div v-if="step.notes"
										class="bg-amber-50 border border-amber-100 rounded-lg p-4 mb-4">
										<div class="flex items-start gap-3">
											<i class="fas fa-exclamation-circle text-amber-500 mt-1"></i>
											<p class="text-amber-700 text-sm">{{ step.notes }}</p>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>

				</div>
			</div>
		</div>






	</div>
</template>

<script>
	export default {
		data() {
			return {

			};
		},
		computed: {
			certificationSteps() {
				return [{
					title: this.$t('language000330'), //启动设备
					description: this.$t('language000331'), //长按设备，当灯色变为蓝灯放手
					notes: this.$t('language000332'), //绿灯闪烁表示设备成功启动，等待连接中,
					completed: false,
					active: false
				}, {
					title: this.$t('language000333'), //连接设备
					description: this.$t('language000334'), //监听设备的UUID，成功监听后设备蓝灯常亮,
					notes: this.$t('language000335'), //蓝灯常亮表示监听成功',
					completed: false,
					active: false
				}, {
					title: this.$t('language000336'), //获取Token
					description: this.$t('language000337'), //调用API 获取设备的Token,
					completed: false,
					active: false
				}, {
					title: this.$t('language000338'), //解密设备命令,
					description: this.$t('language000339'), //调用API 解密设备命令，获取设备返回的Token,
					completed: false,
					active: false
				}, {
					title: this.$t('language000340'), //发送开锁命令
					description: this.$t('language000341'), //调用API 获取设备的开锁命令,
					completed: false,
					active: false
				}, {
					title: this.$t('language000338'), //解密设备命令,
					description: this.$t('language000342'), //调用API 解密设备命令，获取设备返回的结果,
					completed: false,
					active: false
				}];
			},
			certificationSteps4G() {
				return [{
					title: this.$t('language000385'), //设置MQTT服务
					description: this.$t('language000387'), //绑定到平台后,第一次启动4G时候需要进行初始化服务
					notes: this.$t('language000388'), //设置成功后，再次绑定平台后，启动4G需要设置
					completed: false,
					active: false
				}, {
					title: this.$t('language000389'), //设置工作模式
					description: this.$t('language000390'), //不同的工作模式代表了不同的4G工作状态
					notes: this.$t('language000416'),//0表示蓝牙 1表示高频 2表示低频
					completed: false,
					active: false
				},{
					title: this.$t('language000392'), //唤醒设备
					description: this.$t('language000337'), //唤醒设备需要不停的发送唤醒指令，直到设备回复后停止
					notes: this.$t('language000415'),//每两秒发送调一次发送接口进行唤醒，直到设备收到唤醒成功的指令后停止
					completed: false,
					active: false
				}, {
					title: this.$t('language000336'), //获取Token
					description: this.$t('language000419'), //调用API后服务器进行发送指令,
					completed: false,
					active: false
				}, {
					title: this.$t('language000417'), //接收MQTT消息,
					description: this.$t('language000418'), //根据返回的消息处理不同的逻辑
					completed: false,
					active: false
				}, {
					title: this.$t('language000340'), //发送开锁命令
					description: this.$t('language000419'), //调用API后服务器进行发送指令,
					completed: false,
					active: false
				}, {
					title: this.$t('language000417'), //接收MQTT消息,
					description: this.$t('language000418'), //根据返回的消息处理不同的逻辑
					completed: false,
					active: false
				}];
			},
			//...
		}
	};
</script>

<style scoped>
	.group:hover .border-gray-100 {
		border-color: #E5E7EB;
	}
</style>